<script context="module" lang="ts">
  import { writable } from 'svelte/store';

  export let isVisible = writable(false);

  export function openPricingModal() {
    isVisible.set(true);
  }
</script>

<script lang="ts">
  import type { App } from '$lib/types';

  import { getContext } from 'svelte';

  import PricingCards from './PricingCards.svelte';
  import Dialog from '$mds/Dialogs/Dialog.svelte';

  const { isPartner } = getContext<App>('app');

  let dialog;

  $: $isPartner && dialog?.closeModal();
</script>

<Dialog bind:isOpen={$isVisible} bind:dialog scrollerClass="" dialogClass="!overflow-hidden" width="w-[800px]">
  <h3 slot="title" class="text-display-xs text-ondark-primary flex-1 text-balance">Unlock the power of Metafy</h3>
  <div class="text-left">
    <p class="mt-3 text-center">
      Becoming a Metafy Pro is like taking one of those psychedelic-looking mushrooms in Super Mario. It unlocks a whole
      new world of bonus features and resources and it allows you to sell your sessions, guides and goodies for cold
      hard cash.
    </p>

    <PricingCards class="mt-2" on:unlocked />
  </div>
</Dialog>
